export * from './radio';

export interface NiRadioValue {
  key: string | number | boolean;
  value: string | number;
  disabled?: boolean;
}
